import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flow-fabu",
  "use": "icon-flow-fabu-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-flow-fabu\">\r\n<path d=\"M177.9,0.9c3.9-1.4,8.3-1.2,12.1,0.4c3.6,1.5,6.5,4.3,8.3,7.7c1.8,3.5,2.2,7.6,1.2,11.4c-10.7,52.9-21.3,105.8-32,158.8\r\n\tc-0.5,2.4-0.8,4.8-1.7,7.1c-1.5,4.1-4.7,7.5-8.7,9.3c-4,1.8-8.7,2-12.7,0.5c-2.4-0.8-4.3-2.4-6.5-3.6c-10.1-6.3-20.2-12.6-30.3-18.8\r\n\tc-9.9,8.3-19.9,16.5-29.8,24.8c-1.6,1.3-3.8,2-5.8,1.3c-2-0.6-3.5-2.4-4-4.4c-0.4-1.4-0.2-3-0.2-4.4c0-17.3,0-34.6,0-51.8\r\n\tC96.2,109.7,124.6,80.3,153,51c1.6-1.7,3.2-3.5,4.5-5.4c0.4-0.6,0.8-1.3,0.9-2c0-0.6-0.8-0.4-1.1-0.3c-1.7,0.7-3.2,1.8-4.7,2.8\r\n\tc-2.7,2-5.4,4.2-8.1,6.3c-34.3,26.7-68.6,53.5-102.9,80.2c-11-6.8-21.9-13.6-32.9-20.4c-3.1-1.7-5.7-4.4-7.2-7.6\r\n\tc-1.9-4-2-8.7-0.3-12.8c1.7-4.4,5.5-7.8,9.9-9.4C65.5,55.7,119.9,29.1,174.2,2.5C175.4,2,176.6,1.3,177.9,0.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/home/flow-fabu.svg
// module id = 5ixI
// module chunks = 13